function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiIcon = function SvgAiIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.19629 8.46729C1.19629 8.46729 4.428 7.73833 5.69691 6.46942C6.96581 5.20052 7.69477 1.96881 7.69477 1.96881C7.69477 1.96881 8.51454 5.1097 9.78344 6.37861C11.0524 7.64752 14.1932 8.46729 14.1932 8.46729C14.1932 8.46729 10.9615 9.19624 9.69263 10.4651C8.42372 11.7341 7.69477 14.9658 7.69477 14.9658C7.69477 14.9658 6.875 11.8249 5.60609 10.556C4.33719 9.28705 1.19629 8.46729 1.19629 8.46729Z",
    fill: "url(#paint0_linear_479_47511)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3.29761C1 3.29761 2.14259 3.03988 2.59121 2.59125C3.03984 2.14263 3.29757 1.00004 3.29757 1.00004C3.29757 1.00004 3.5874 2.11052 4.03603 2.55915C4.48465 3.00777 5.59513 3.29761 5.59513 3.29761C5.59513 3.29761 4.45255 3.55533 4.00392 4.00396C3.55529 4.45259 3.29757 5.59517 3.29757 5.59517C3.29757 5.59517 3.00773 4.4847 2.55911 4.03607C2.11048 3.58744 1 3.29761 1 3.29761Z",
    fill: "url(#paint1_linear_479_47511)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 5.02075C10.7646 5.02075 11.3359 4.89189 11.5603 4.66758C11.7846 4.44326 11.9134 3.87197 11.9134 3.87197C11.9134 3.87197 12.0583 4.42721 12.2827 4.65152C12.507 4.87584 13.0622 5.02075 13.0622 5.02075C13.0622 5.02075 12.4909 5.14961 12.2666 5.37393C12.0423 5.59824 11.9134 6.16953 11.9134 6.16953C11.9134 6.16953 11.7685 5.61429 11.5442 5.38998C11.3199 5.16567 10.7646 5.02075 10.7646 5.02075Z",
    fill: "url(#paint2_linear_479_47511)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_479_47511",
    x1: 7.89264,
    y1: 2.72339,
    x2: 9.61581,
    y2: 13.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FB",
    style: _defineProperty(_defineProperty({
      stopColor: "#FF00FB"
    }, "stopColor", "color(display-p3 1.0000 0.0000 0.9833)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EEFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#00EEFF"
    }, "stopColor", "color(display-p3 0.0000 0.9333 1.0000)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_479_47511",
    x1: 3.36753,
    y1: 1.26683,
    x2: 3.97676,
    y2: 5.22685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FB",
    style: _defineProperty(_defineProperty({
      stopColor: "#FF00FB"
    }, "stopColor", "color(display-p3 1.0000 0.0000 0.9833)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EEFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#00EEFF"
    }, "stopColor", "color(display-p3 0.0000 0.9333 1.0000)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_479_47511",
    x1: 11.9484,
    y1: 4.00536,
    x2: 12.253,
    y2: 5.98537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FB",
    style: _defineProperty(_defineProperty({
      stopColor: "#FF00FB"
    }, "stopColor", "color(display-p3 1.0000 0.0000 0.9833)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EEFF",
    style: _defineProperty(_defineProperty({
      stopColor: "#00EEFF"
    }, "stopColor", "color(display-p3 0.0000 0.9333 1.0000)"), "stopOpacity", 1)
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai_icon.10a6e0227c52498d8d01d11aa7a699d3.svg";